import { api } from 'api'

export type WorkShiftCustomField = {
  id: number
  key: string
  required: boolean
  deletedAt: string | null
}

type ListWorkShiftCustomFieldsRequest = {
  includeDeleted?: boolean
}

type ListWorkShiftCustomFieldsResponse = {
  workShiftCustomFields: WorkShiftCustomField[]
}

type CreateWorkShiftCustomFieldRequest = {
  key: string
}

type CreateWorkShiftCustomFieldResponse = WorkShiftCustomField

type UpdateWorkShiftCustomFieldRequest = {
  key: string
}

type UpdateWorkShiftCustomFieldResponse = WorkShiftCustomField

export async function listWorkShiftCustomFields(
  companyId: number,
  params: ListWorkShiftCustomFieldsRequest = {}
) {
  const response = await api.get<ListWorkShiftCustomFieldsResponse>(
    `/company/${companyId}/work_shift_custom_fields`,
    {
      params: {
        includeDeleted: params.includeDeleted,
      },
    }
  )
  return response.data
}

export async function createWorkShiftCustomField(
  companyId: number,
  body: CreateWorkShiftCustomFieldRequest
) {
  const response = await api.post<CreateWorkShiftCustomFieldResponse>(
    `/company/${companyId}/work_shift_custom_fields`,
    body
  )
  return response.data
}

export async function updateWorkShiftCustomField(
  companyId: number,
  customFieldId: number,
  body: UpdateWorkShiftCustomFieldRequest
) {
  const response = await api.put<UpdateWorkShiftCustomFieldResponse>(
    `/company/${companyId}/work_shift_custom_fields/${customFieldId}`,
    body
  )
  return response.data
}

export async function deleteWorkShiftCustomField(
  companyId: number,
  customFieldId: number
) {
  await api.delete<void>(
    `/company/${companyId}/work_shift_custom_fields/${customFieldId}`
  )
}
